module.exports = __webpack_public_path__ + "static/elisa-85e2a5d2e6f73d873f92fa2acce117a9.svg";